module.exports = function isPrivatePath(path) {
	const privateRoute = process.env.GATSBY_PRIVATE_ROUTE || "";
	if (privateRoute === "" || !path) return false;
	return privateRoute === "/" || path === privateRoute || path.includes(privateRoute);
};
